import {GET_PEGAWAI} from 'shared/constants/ActionTypes';

const INIT_STATE = {
  detail: '',
};

export const getPegawaiReducers = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PEGAWAI:
      return {
        ...state,
        detail: action.payload.detail,
      };
    default:
      return state;
  }
};

export default getPegawaiReducers;
